import sideImage from "../images/afro-solar/solution-for-commertial/Add a heading.webp";

const industrialsSolutions = [
  {
    title: "Locked-in Electricity Rates",
    description:
      "Hedge against future electricity price increases & volatility generating annual energy savings.",
  },
  {
    title: "Improved CSR",
    description:
      "Exceed the expectations of stakeholders and add sustainability to your CSR efforts.",
  },
  {
    title: "Increased Brand Equity",
    description:
      "Promoting your sustainability values and ​shine in the market.",
  },
  {
    title: "No upfront costs,",
    description:
      "​no financial burden; we take over from A-Z. We design, secure funds, install and maintain system.​",
  },
  {
    title: "Improved company Cashflow",
    description:
      "Simply pay for the power you consume, at a locked-in rate always cheaper than grid.​",
  },
  {
    title: "Turn-key solutions",
    description: "We design, fund, install and maintain your solar system. ",
  },
];

const CommercialSolution = () => {
  return (
    <div className="container-fluid pt-7">
      <div className="ms-13 me-13">
        <div className="row">
          <div className="col-12 col-md-12 col-lg-6 text-center mb-5 mb-lg-0">
            <img
              src={sideImage}
              alt="solution for industrial"
              className="img-fluid"
            />
          </div>
          <div className="col-12 col-md-12 col-lg-6 my-auto">
            {industrialsSolutions.map((solution, index) => (
              <div className="row" key={solution.title}>
                <h2
                  className="col-2 text-24 gilroy-bold bg-american-yellow text-center me-4"
                  style={{
                    height: "40px",
                    width: "40px",
                    borderRadius: "50%",
                    lineHeight: "40px",
                  }}
                >
                  {index + 1}
                </h2>
                <div className="col-10">
                  <h3 className="fs-18 gilroy-bold">{solution.title}</h3>
                  <p className="fs-16">{solution.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommercialSolution;
